// extracted by css-extract-rspack-plugin
export default {"AddCommentEditor":"AddCommentEditor-module__AddCommentEditor__mxsckGr"};